import {queryOptions, infiniteQueryOptions} from '@tanstack/react-query';
import {
  accountsCheckinsList,
  accountsCheckinsRetrieve,
  checkinsOptionsList,
} from 'api/v2';
import type {AccountsCheckinsListParams} from 'api/v2';

export const checkinsQueryKeys = {
  all: () => ['checkins'],
  detail: (id: string) => [...checkinsQueryKeys.all(), 'detail', id],
  list: (params: AccountsCheckinsListParams) => [
    ...checkinsQueryKeys.all(),
    'list',
    params,
  ],
  infiniteList: (params: AccountsCheckinsListParams) => [
    ...checkinsQueryKeys.all(),
    'infiniteList',
    params,
  ],
  optionsList: () => [...checkinsQueryKeys.all(), 'optionsList'],
};

const checkinsDetail = (id: string) =>
  queryOptions({
    queryKey: checkinsQueryKeys.detail(id),
    queryFn: () => accountsCheckinsRetrieve(id),
    select: (data) => data.data,
  });

const checkinsList = (params: AccountsCheckinsListParams) =>
  queryOptions({
    queryKey: checkinsQueryKeys.list(params),
    queryFn: () => accountsCheckinsList(params),
    select: (data) => data.data,
  });

const checkinsInfiniteList = (params: AccountsCheckinsListParams) =>
  infiniteQueryOptions({
    queryKey: checkinsQueryKeys.infiniteList(params),
    queryFn: async ({pageParam = 1}) => {
      const response = await accountsCheckinsList({
        ...params,
        page: pageParam,
      });
      return {
        data: response.data,
        nextPage: response.data.next ? pageParam + 1 : null,
      };
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) => lastPage?.nextPage,
  });

const optionsList = () =>
  queryOptions({
    queryKey: checkinsQueryKeys.optionsList(),
    queryFn: () => checkinsOptionsList({pageSize: 999}),
    select: (data) => data.data,
    staleTime: 60 * 60 * 1000,
  });

export const checkinsQueryOptions = {
  detail: checkinsDetail,
  list: checkinsList,
  infiniteList: checkinsInfiniteList,
  optionsList: optionsList,
};
